
import Vue from "vue";
import Component from "vue-class-component";
import {getOrdersMapLocation, formatDecimal, formatBool} from "@/utils";
import {Truck} from "@/models/api/trucks/getTrucks";
import {Prop, Watch} from "vue-property-decorator";
import {GoogleMapInterface} from "@/models/ui/googleMapVue";
import {GREEN_MAP_PIN_ICON, MAP_STYLES, RED_MAP_PIN_ICON, PURPLE_MAP_PIN_ICON} from "@/consts";
import {TruckModule} from "@/store/modules";
import notifications from "../../lib/notifications";
import {getModule} from "vuex-module-decorators";
import _ from "lodash";

const truckModule = getModule(TruckModule);

declare global {
  interface Window {
    truckInfoWindowButtonClick: Function;
    showGeocodeModal: Function;
  }
}

@Component({
  data: () => {
    return {
      customBus: new Vue(),
    };
  },
})
export default class TruckMapViewModal extends Vue {
  @Prop({required: false, default: () => null})
  public truck: Truck;

  @Prop({required: false, default: () => false})
  public allowRemove: boolean;

  truckSelectedMapOrder: any = null;
  truckInfoWindowOpened: boolean = false;
  truckInfoWindowOptions: any = null;
  truckInfoWindowPos: any = null;
  mapZoomLevel: number = 10;
  modalVisible: boolean = false;
  mapCenter: any = null;
  mapOptions: any = null;
  showCoordinateEdit: boolean = false;
  editLat: number = 0;
  editLng: number = 0;
  dragLat: number = 0;
  dragLng: number = 0;
  showDragActions: boolean = false;
  showGeocodeButton: boolean = true;
  contact: any = {
    location: null
  };
  truckOrders: any[] = this.truck ? this.truck.orders : [];
  truckOrdersWithGPS: any[] = truckModule.currentTruck ? truckModule.currentTruck.orders.filter((x) => x.location) : [];

  created() {
    const vm = this;
    window.truckInfoWindowButtonClick = function () {
      vm.removeOrderFromMap();
    };
    window.showGeocodeModal = function () {
      vm.showGeocodeModal();
    }

    this.$store.watch((state) => state.truck.currentTruck.orders, (newVal, oldVal) => {
      this.truckOrdersWithGPS = newVal.filter((x) => x.location);
    });
  }

  @Watch("truck", {immediate: true})
  onTruckChange(val: Truck) {
    if (
      this.truck &&
      this.truckOrdersWithGPS &&
      this.truckOrdersWithGPS.length > 0
    ) {
      let mapInfo = getOrdersMapLocation(this.truckOrdersWithGPS);
      this.mapCenter = {lat: mapInfo.latCenter, lng: mapInfo.lngCenter};
      this.mapZoomLevel = mapInfo.zoomLevel;
    } else {
      this.mapCenter = {lat: 0, lng: 0};
      this.mapZoomLevel = 10;
    }
  }

  mapOptions2() {
    return {
      styles: [
        {
          featureType: "poi",
          stylers: [{visibility: "off"}]
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{visibility: "off"}]
        }
      ]
    };
  }

  mapCoordinates() {
    if (!this.truckSelectedMapOrder
      || !this.truckSelectedMapOrder.stopParty
      || !this.truckSelectedMapOrder.stopParty.location
    ) return this.mapCenter
    if (this.dragLat !== 0 && this.dragLng !== 0) return {lat: this.dragLat, lng: this.dragLng};
    return {
      lat: this.truckSelectedMapOrder.stopParty.location.latitude,
      lng: this.truckSelectedMapOrder.stopParty.location.longitude
    };
  }

  mapCenter2() {
    if (!this.truckSelectedMapOrder
      || !this.truckSelectedMapOrder.stopParty
      || !this.truckSelectedMapOrder.stopParty.location)
      return this.mapCenter
    return {
      lat: this.truckSelectedMapOrder.stopParty.location.latitude,
      lng: this.truckSelectedMapOrder.stopParty.location.longitude
    };
  }


  getCurrentLat(): any {
    if (this.dragLat === 0) {
      const valueToParse = !this.truckSelectedMapOrder ||
      !this.truckSelectedMapOrder.stopParty ||
      !this.truckSelectedMapOrder.stopParty.location
        ? 0
        : this.truckSelectedMapOrder.stopParty.location.latitude;
      return parseFloat(valueToParse).toFixed(5);
    }
    return parseFloat(this.dragLat.toString()).toFixed(5);
  }

  getCurrentLong(): any {
    if (this.dragLat === 0) {
      const valueToParse = !this.truckSelectedMapOrder ||
      !this.truckSelectedMapOrder.stopParty ||
      !this.truckSelectedMapOrder.stopParty.location
        ? 0
        : this.truckSelectedMapOrder.stopParty.location.longitude;
      return parseFloat(valueToParse).toFixed(5);
    }
    return parseFloat(this.dragLat.toString()).toFixed(5);
  }

  coordinateEdit() {
    this.showCoordinateEdit = true;
    this.editLat = this.getCurrentLat();
    this.editLng = this.getCurrentLong();
  }

  selectTruckMapOrder(order) {
    if(order && !this.truckOrdersWithGPS.includes(order))
    {
      let orderIndex = this.truckOrdersWithGPS.findIndex(
        (x) => x.id == order.id
      );
      if(orderIndex >= 0) {
        order = this.truckOrdersWithGPS[orderIndex];
      }
    }

    this.truckSelectedMapOrder = order;
    this.truckInfoWindowOptions = this.getTruckInfoWindowOptions();
    this.truckInfoWindowPos = this.getOrderPosition(order);
    this.truckInfoWindowOpened = order != null && this.truckInfoWindowPos != null;
  }

  geoCodeTruckOrder(order) {
    if(!truckModule.currentTruck || !truckModule.currentTruck.orders)
      return;
    let orderIndex = truckModule.currentTruck.orders.findIndex(
      (x) => x.id == order.id
    );
    if(orderIndex >= 0)
    {
      this.selectTruckMapOrder(truckModule.currentTruck.orders[orderIndex]);
      this.showGeocodeModal();
    }
  }

  getOrderPosition(order: any) {
    if (order && order.location)
      return {lat: order.location.latitude, lng: order.location.longitude};
    return null;
  }

  getOrderMapIcon(order: any) {
    if (order && order.deliveryType == "RETURN"){
      return PURPLE_MAP_PIN_ICON;
    }

    if (order && (order.location && order.location.isZipCodeLocation == true))
      return RED_MAP_PIN_ICON;
    return GREEN_MAP_PIN_ICON;
  }

  getMapOptions() {
    return MAP_STYLES;
  }

  getTruckMarkerLabel(order: any) {
    const index = this.truckOrdersWithGPS.findIndex((x) => x.id == order.id);
    if (index >= 0)
      return {
        color: "white",
        fontWeight: "bold",
        text: (index + 1).toString(),
      };
    return null;
  }

  getTruckInfoWindowOptions() {
    if (this.truckSelectedMapOrder) {
      return {
        content:
          "<h5>" +
          this.truckSelectedMapOrder.sequence + " - " + this.truckSelectedMapOrder.stopParty.name +
          "</h5><b>SYS #:</b>" +
          this.truckSelectedMapOrder.orderHeaderNumber +
          "<br> <b>CRN:</b> " +
          this.truckSelectedMapOrder.crn +
          "<br> <b>Cubes:</b> " +
          this.truckSelectedMapOrder.cubes +
          "<br> <b>Received:</b> " +
          formatBool(this.truckSelectedMapOrder.isReceived) +
          "<br><b>Unit Count:</b>" +
          this.truckSelectedMapOrder.unitCount +
          "<br/><br>" +
          this.truckSelectedMapOrder.stopParty.name +
          "<br/>" +
          this.truckSelectedMapOrder.stopParty.address.streetLine1 +
          "<br/>" +
          this.truckSelectedMapOrder.stopParty.address.city +
          ", " +
          this.truckSelectedMapOrder.stopParty.address.state +
          " " +
          this.truckSelectedMapOrder.stopParty.address.zip +
          "<br/>" +
          (this.allowRemove
            ? "<a href='javascript:void(0)' onclick='truckInfoWindowButtonClick()'>Remove From Truck</a>"
            : "")
          + "<br> <a href='javascript:void(0)' onclick='showGeocodeModal()'>Geocode Address</a>",
      };
    }
    return null;
  }

  cancelGeocodeModal() {
    this.$bvModal.hide("geocodeModal");
  }

  resetGeocodeModal() {
    this.resetMarker();
    this.showCoordinateEdit = false;
  }

  showGeocodeModal() {
    this.modalVisible = true;
  }

  dragEnd(event) {
    this.dragLat = event.latLng.lat();
    this.dragLng = event.latLng.lng();
    if (this.showCoordinateEdit === true) {
      this.editLat = Number(parseFloat(event.latLng.lat()).toFixed(5));
      this.editLng = Number(parseFloat(event.latLng.lng()).toFixed(5));
    }
    this.showGeocodeButton = false;
    this.showDragActions = true;
  }

  async geoCodeAddress() {
    try {
      await truckModule.geoCodeAddress({
        companyId: this.truckSelectedMapOrder.stopParty.id,
        orderHeader: this.truckSelectedMapOrder.orderHeaderNumber,
        address: this.truckSelectedMapOrder.stopParty.address,
        orderId: this.truckSelectedMapOrder.id
      })
      this.repopulateOrders();
      notifications.success("Address Geocoded", "Address successfully geocoded.")
      this.modalVisible = false;
    } catch {
      notifications.error("Address Not Geocoded", "Failed to geocode address.")
    }
  }

  resetMarker() {
    this.dragLat = 0;
    this.dragLng = 0;
    this.showDragActions = false;
    this.showGeocodeButton = true;
  }

  async saveEditCoordinate() {
    try {
      await truckModule.updateAddressCoordinates({
        latitude: parseFloat(this.editLat.toString()),
        longitude: parseFloat(this.editLng.toString()),
        id: this.truckSelectedMapOrder.stopParty.id,
        orderHeader: this.truckSelectedMapOrder.orderHeaderNumber,
        orderId: this.truckSelectedMapOrder.id
      });
      this.showCoordinateEdit = false;
      this.editLat = 0;
      this.editLng = 0;
      this.resetMarker();    
      this.repopulateOrders();
      notifications.success("Coordinate update successful", "Coordinate update successful.");
    } catch {
      notifications.error("Update failed", "Coordinate update failed. Please try again.");
    }
  }

  async updateCoordinates() {
    try {
      await truckModule.updateAddressCoordinates({
        latitude: this.dragLat,
        longitude: this.dragLng,
        id: this.truckSelectedMapOrder.stopParty.id,
        orderHeader: this.truckSelectedMapOrder.orderHeaderNumber,
        orderId: this.truckSelectedMapOrder.id
      });
      this.repopulateOrders();
      notifications.success("Address Geocoded", "Address successfully geocoded.")
      this.modalVisible = false;
    } catch {
      notifications.error("Address Not Geocoded", "Failed to geocode address.")
    }
  }

  repopulateOrders()
  {
    this.truckOrdersWithGPS = truckModule.currentTruck ? truckModule.currentTruck.orders.filter((x) => x.location) : [];
    this.selectTruckMapOrder(this.truckSelectedMapOrder);
    this.$emit("repopulateOrder", this.truckSelectedMapOrder);
  }

  removeOrderFromMap() {
    if (this.allowRemove && this.truckSelectedMapOrder) {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you wish to remove order ${this.truckSelectedMapOrder.id} from truck ${this.truck.name}? This action cannot be undone.`
        )
        .then((value) => {
          if (value) {
            truckModule
              .removeOrderFromTruck({
                truckId: this.truck.id,
                orderId: this.truckSelectedMapOrder.id,
              })
              .then(() => {
                notifications.success(
                  "Order Removed",
                  "Order successfully removed from truck."
                );
                truckModule
                  .getTruck(this.truck.id)
                  .then((value) => (this.truck = value));
                if (
                  truckModule.currentTruck &&
                  truckModule.currentTruck.id == this.truck.id
                )
                  truckModule.reloadTruck();
                this.selectTruckMapOrder(null);
              })
              .catch((ex) => {
                notifications.error(
                  "Order Not Removed",
                  "Failed to remove order from truck",
                  ex
                );
              });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    }
  }

  refreshMap() {
    var truckMap = this.$refs.truckMap as GoogleMapInterface;
    var vue = this;
    truckMap.$mapPromise.then((map) => {
      vue.$data.customBus.$emit("resize");
    });
  }
}
